<template>
  <div class="index">
    <keep-alive :include="$store.state.keepAlivePages" max="5">
      <router-view></router-view>
    </keep-alive>
    <tab-bar :whichTabBarList="whichTabBarList"></tab-bar>
  </div>
</template>
<script>
import TabBar from '@/components/index/TabBar'
import store from '@/store'
import { CHANNEL } from '@/config/common.js'
import {getUrlParams} from "@/utils/tool"
const companyConfig = {
  id: 5,
  icon: 'tabbar_icon_ent_def',
  activeIcon: 'tabbar_icon_tuanjian_sel',
  redirect: true, // 是否跳转外链
  text: '团检',
  link: '/mine',
  hmtEvent: {
    type: 'click',
    category: '中台/首页',
    action: '点击切换团检'
  }
}

const TABBAR_LIST = [
  {
    id: 0,
    text: '首页',
    icon: 'tabbar_icon_home_def',
    activeIcon: 'tabbar_icon_home_sel',
    link: '/home',
    hmtEvent: {
      type: 'click',
      category: '中台/首页',
      action: '点击切换首页'
    }
  },
  {
    id: 1,
    icon: 'tabbar_icon_shop_def',
    activeIcon: 'tabbar_icon_shop_sel',
    text: '商城',
    link: '/mall',
    hmtEvent: {
      type: 'click',
      category: '中台/首页',
      action: '点击切换商城'
    }
  },
  {
    id: 2,
    icon: 'tabbar_icon_heal_def',
    activeIcon: 'tabbar_icon_heal_sel',
    text: '资讯',
    link: '/health',
    hmtEvent: {
      type: 'click',
      category: '中台/首页',
      action: '点击切换资讯'
    }
  },
  {
    id: 3,
    icon: 'tabbar_icon_mine_def',
    activeIcon: 'tabbar_icon_mine_sel',
    text: '我的',
    link: '/mine',
    hmtEvent: {
      type: 'click',
      category: '中台/首页',
      action: '点击切换我的'
    }
  }
]

const TABBAR_LIST2 = [
  {
    id: 0,
    text: '首页',
    icon: 'tabbar_icon_home_def',
    activeIcon: 'tabbar_icon_home_sel',
    link: '/home',
    hmtEvent: {
      type: 'click',
      category: '中台/首页',
      action: '点击切换首页'
    }
  },
  {
    id: 1,
    icon: 'tabbar_icon_heal_def',
    activeIcon: 'tabbar_icon_heal_sel',
    text: '资讯',
    link: '/health',
    hmtEvent: {
      type: 'click',
      category: '中台/首页',
      action: '点击切换资讯'
    }
  },
  {
    id: 2,
    icon: 'tabbar_icon_mine_def',
    activeIcon: 'tabbar_icon_mine_sel',
    text: '我的',
    link: '/mine',
    hmtEvent: {
      type: 'click',
      category: '中台/首页',
      action: '点击切换我的'
    }
  }
]

const ZHENAI_LIST = [
  {
    id: 0,
    icon: 'tabbar_icon_home_def',
    text: '首页',
    activeIcon: 'tabbar_icon_home_sel',
    link: '/zhenai'
  },
  {
    id: 1,
    icon: 'tabbar_icon_mine_def',
    activeIcon: 'tabbar_icon_mine_sel',
    text: '我的',
    link: '/mine'
  }
]
export default {
  name: 'index',
  components: {
    TabBar
  },
  data() {
    return {
      tabBarList: sessionStorage.getItem('channel') === '005_03_0001_0000_00' ? TABBAR_LIST2 : TABBAR_LIST,
      zhenaiTabList: Object.freeze(ZHENAI_LIST)
    }
  },
  computed: {
    isTitleBar() {
      return this.$route.meta.titleBar
    },
    whichTabBarList() {
      if (this.$route.path === '/zhenai' || this.$storage.getItem('comefrom') === 'zhenai') {
        return this.zhenaiTabList
      } else {
        return this.tabBarList
      }
    }
  },
  beforeRouteEnter: (to, from, next) => {
    // 增加中台小程序需要的token参数
    var token = getUrlParams(window.location.href)["miniappToken"];

      if (token) {
        localStorage.setItem("miniappToken", token);
      }
    next((vm) => {
      console.log('beforeRouteEnter')
      vm.init()
    })
  },
  methods: {
    init() {
      let params
      if (store.state.channel === CHANNEL) {
        params = {
          with_point: 1,
          with_tijian: 1,
          channel: CHANNEL
        }
      } else {
        params = {
          with_point: 1,
          with_tijian: 1
        }
      }

      this.$store.dispatch('user/getNewUserInfo', { params: params, withoutLogin: true }).then((res) => {
        this.$store.commit('user/SET_AUTH_STATUS', !!(res.code !== 510))
        if (res.code === 200) {
          const vipDetail = res.data.vip_detail
          let vipStatus
          if (vipDetail && vipDetail.is_new && vipDetail.is_new === 1) {
            vipStatus = 1
          } else if (vipDetail && vipDetail.is_vip && vipDetail.is_vip === 1) {
            vipStatus = 2
          } else {
            vipStatus = 3
          }
          if (!vipDetail) return
          const vips = Object.assign(vipDetail, {
            vipStatus
          })
          this.$store.commit('GET_VIP_DETAIL', vips)
          // 团检信息
          const company = res.data.company
          if (company && company.length !== 0) {
            const arr = this.tabBarList.slice()
            companyConfig.link = company.link_to
            companyConfig.text = company.sub_name
            if (this.tabBarList.findIndex((v) => v.text === companyConfig.text) > -1) {
              return
            }
            this.tabBarList.splice(2, 0, companyConfig)
          }
        }

        // 健康卡信息
        if (res.data && res.data.active_card_show && res.data.active_card_show.data) {
          const { show: homeShow, end_day, level, not_use_count, sum_count } = res.data.active_card_show.data
          this.$store.commit('SET_AGENT_INFO', {
            end_day,
            homeShow,
            level,
            not_use_count,
            sum_count
          })
        }

        this.healthCardInfoRequest = true
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/style/mixin.less';
.index {
  padding-bottom: 100px;
  .safe-padding-bottom(100px);
}
</style>
